import { BusinessHomepageLayout } from "./BusinessHomepageLayout";
import { TripBuildingPage } from "./pages/TripBuildingPage";

export default function BusinessTripBuildingPage() {
	return (
		<BusinessHomepageLayout>
			<TripBuildingPage />
		</BusinessHomepageLayout>
	);
}
